<template>
  <div class="configurator-order">
    <form
      class="configurator-order-position"
      :class="{'product-order-position__flyout': flyout}"
    >
      <div
        class="configurator-order-position__cell configurator-order-position__cell--image"
        :class="{'configurator-order-position__flyout__cell--image' : flyout}"
      >
        <a
          v-if="image"
        >
          <img
            class="configurator-order-position__image"
            :src="image.src"
            :title="image.title"
            :alt="image.alt"
            width="80"
            height="80"
            loading="lazy"
          >
        </a>
      </div>

      <div
        class="configurator-order-position__cell"
        :class="[flyout ? 'configurator-order-position__flyout__cell--info' : 'configurator-order-position__cell--info']"
      >
        <div :class="{ 'configurator-order-position__flyout--name-price' : flyout }">
          <div
            class="configurator-order-position__name"
            :class="{'configurator-order-position__flyout--name' : flyout}"
          >
            {{ name }}
          </div>
          <div
            v-if="flyout"
            class="product-order-position__flyout--price"
          >
            <span
              class="product-order-position__flyout--price"
            >
              {{ totalPrice }}
            </span>
          </div>
        </div>
        <div class="configurator-order-position--headline">
          {{ $t('configurator.order.position.article_description.header') }}
        </div>
        <div
          class="configurator-order-position--description"
          :class="{'configurator-order-position__flyout--description' : flyout}"
        >
          {{ $t('configurator.order.position.article_description', [fefcoType, color, height, length, width, quality]) }}
          <br>
        </div>
      </div>

      <template v-if="!flyout">
        <div class="configurator-order-position__cell configurator-order-position__cell--price">
          <span class="configurator-order-position__price">
            <i>{{ singlePrice }}</i>
          </span>
        </div>

        <div
          v-if="type === 'orderTable'"
          class="configurator-order-position__cell configurator-order-position__cell--quantity"
        >
          <span>{{ quantity }}</span>
        </div>

        <div
          class="configurator-order-position__cell configurator-order-position__cell--remove"
          :class="{
            'configurator-order-position__cell--empty': !editable,
            'configurator-order-position__flyout__cell' : flyout
          }"
        >
          <template v-if="editable">
            <span
              class="configurator-order-position__remove"
              :aria-label="$t('remove.product.button.label')"
              @click="removeFromCart()"
              @keydown="handleKeyDown"
              role="button"
            />
          </template>

          <template v-else-if="type === 'minicart'">
            <div class="configurator-order-position__flyout--actions">
              <span class="configurator-order-position__flyout--action__divide" />
              <span
                class="configurator-order-position__flyout--action configurator-order-position__flyout--action__delete"
                @click.prevent="removeFromFlyout()"
              >
                {{ $t('global.article.remove.button') }}
              </span>
            </div>
          </template>
        </div>

        <div
          v-if="type === 'orderTable'"
          class="configurator-order-position__cell configurator-order-position__cell--summary"
        >
          <span class="configurator-order-position__price">
            {{ totalPrice }}
          </span>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js'

export default {
  mixins: [
    globalStateComputedMixin
  ],
  props: {
    image: Object,
    name: String,
    quantity: Number,
    entryId: String,
    singlePrice: String,
    totalPrice: String,
    fefcoType: String,
    color: String,
    height: Number,
    length: Number,
    width: Number,
    quality: String,
    isSelected: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    index: Number,
    type: String,
    flyout: Boolean,
    actionId: String,
    actionUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    positionType() {
      return this.type === 'cart'
    }
  },
  methods: {
    removeFromCart() {
      this.$store.dispatch('cartPage/removeSingleProduct', {
        entryId: this.entryId,
        _csrf: this.csrfToken.value
      })
    },
    removeFromFlyout() {
      this.$store.dispatch('reduceCount', {flyout: 'cart'})
      let data = {}
      data['itemId'] = this.productId
      data['type'] = 'delete'
      this.removeFromCart()
      this.$store.dispatch('editArticleInFlyout', data)
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        event.target.click();
      }
    }
  }
}

</script>
